export default {
  linearRegressionHeadline: 'Lineare Regression',
  ployfit: {
    headline: 'Polynomfit',
    degree: 'Grad des Polynoms',
  },
};
